import { Daisy as Spinner } from '@/ds-components/Spinner';

import styles from './index.module.scss';

function AppLoading() {
  return (
    <div className={styles.container} role="status" aria-label="Opening Identity Management">
      <Spinner />
    </div>
  );
}

export default AppLoading;
